import request from './request'

export const loginApi = (data) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export const register = (data) => {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export const registerApi = register

export const getTools = (params) => {
  return request({
    url: '/tools',
    method: 'get',
    params
  })
}

export const getToolDetail = (id) => {
  return request({
    url: `/tools/${id}`,
    method: 'get'
  })
}

export const getToolImage = (id) => {
  return request({
    url: `/tools/${id}/image`,
    method: 'get'
  })
}

// ============ 基因组文件夹浏览 ============

export const getGenomeFolders = () => {
  return request({
    url: '/genome/folders',
    method: 'get'
  })
}

// ============ 工具文件上传 ============

export const uploadToolFile = (toolId, paramName, formData, onUploadProgress) => {
  return request({
    url: `/tools/${toolId}/upload`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: { param_name: paramName },
    timeout: 600000,
    onUploadProgress
  })
}

// ============ 数据集/文件相关接口 ============

export const uploadDataset = (formData, onUploadProgress) => {
  const token = localStorage.getItem('token')
  return request({
    url: '/datasets/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: token ? { token } : {},
    timeout: 600000,
    onUploadProgress
  })
}

export const pasteDataset = (data) => {
  const token = localStorage.getItem('token')
  return request({
    url: '/datasets/paste',
    method: 'post',
    data,
    params: token ? { token } : {}
  })
}

export const getDatasetPreview = (datasetId, params) => {
  return request({
    url: `/datasets/${datasetId}/preview`,
    method: 'get',
    params
  })
}

// ============ 服务器文件浏览接口 ============

export const listServerFiles = (path = '') => {
  const token = localStorage.getItem('token')
  return request({
    url: '/files/server',
    method: 'get',
    params: { path, token }
  })
}

export const selectServerFile = (path) => {
  const token = localStorage.getItem('token')
  return request({
    url: '/files/server/select',
    method: 'post',
    data: { path },
    params: token ? { token } : {}
  })
}

// ============ 任务相关接口 ============

// 创建普通任务
export const createTask = (data) => {
  return request({
    url: '/tasks',
    method: 'post',
    data
  })
}

// 创建基因家族鉴定任务
export const createGeneFamilyTask = (data) => {
  return request({
    url: '/tasks/gene-family',
    method: 'post',
    data
  })
}

export const getTaskStatus = (taskId) => {
  return request({
    url: `/tasks/${taskId}`,
    method: 'get'
  })
}

export const getTaskLogs = (taskId, params) => {
  return request({
    url: `/tasks/${taskId}/logs`,
    method: 'get',
    params
  })
}

export const downloadResult = (taskId, filename = null) => {
  return request({
    url: `/tasks/${taskId}/result/download`,
    method: 'get',
    params: filename ? { file: filename } : {},
    responseType: 'blob'
  })
}

export const downloadTaskData = (taskId) => {
  return request({
    url: `/tasks/${taskId}/result/data`,
    method: 'get',
    responseType: 'blob'
  })
}

// 获取任务结果目录树
export const getTaskResultTree = (taskId) => {
  return request({
    url: `/tasks/${taskId}/result/tree`,
    method: 'get'
  })
}

// 下载结果文件或文件夹
export const downloadResultFile = (taskId, path) => {
  return request({
    url: `/tasks/${taskId}/result/download`,
    method: 'get',
    params: { path },
    responseType: 'blob'
  })
}

// ============ 分类和其他接口 ============

export const getCategories = () => {
  return request({
    url: '/categories',
    method: 'get'
  })
}

export const createCategoryApi = (data) => {
  return request({
    url: '/categories',
    method: 'post',
    data
  })
}

export const deleteCategoryApi = (name) => {
  return request({
    url: `/categories/${encodeURIComponent(name)}`,
    method: 'delete'
  })
}

export const changePasswordApi = (data) => {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data
  })
}

// ============ 邀请码管理接口 ============

export const generateInviteCodesApi = (data) => {
  const token = localStorage.getItem('token') || ''
  return request({
    url: '/invite-codes/generate',
    method: 'post',
    data,
    params: { token }
  })
}

export const getInviteCodesApi = (params = {}) => {
  const token = localStorage.getItem('token') || ''
  return request({
    url: '/invite-codes',
    method: 'get',
    params: { ...params, token }
  })
}

export const deleteInviteCodeApi = (id) => {
  const token = localStorage.getItem('token') || ''
  return request({
    url: `/invite-codes/${id}`,
    method: 'delete',
    params: { token }
  })
}

export const selectAvatarApi = (data) => {
  return request({
    url: '/auth/select-avatar',
    method: 'post',
    data
  })
}

export const getUserTasks = (userId) => {
  return request({
    url: `/tasks/history/${userId}`,
    method: 'get'
  })
}

export const deleteTask = (taskId) => {
  return request({
    url: `/tasks/${taskId}`,
    method: 'delete'
  })
}

export const cancelTask = (taskId) => {
  return request({
    url: `/tasks/${taskId}/cancel`,
    method: 'post'
  })
}

export const createToolApi = (data) => {
  return request({
    url: '/tools',
    method: 'post',
    data
  })
}

export const updateToolApi = (id, data) => {
  return request({
    url: `/tools/${id}`,
    method: 'put',
    data
  })
}

export const deleteToolApi = (id) => {
  return request({
    url: `/tools/${id}`,
    method: 'delete'
  })
}

export const cloneToolApi = (id) => {
  const token = localStorage.getItem('token')
  return request({
    url: `/tools/${id}/clone`,
    method: 'post',
    params: token ? { token } : {}
  })
}

// ============ 评论接口 ============

export const getToolComments = (toolId) => {
  return request({
    url: `/tools/${toolId}/comments`,
    method: 'get'
  })
}

export const addToolComment = (toolId, data) => {
  const token = localStorage.getItem('token')
  return request({
    url: `/tools/${toolId}/comments`,
    method: 'post',
    data,
    params: token ? { token } : {}
  })
}

export const deleteToolComment = (toolId, commentId) => {
  const token = localStorage.getItem('token')
  return request({
    url: `/tools/${toolId}/comments/${commentId}`,
    method: 'delete',
    params: token ? { token } : {}
  })
}

// ============ PDF 预览接口 ============

export const previewTaskPdf = (taskId) => {
  return request({
    url: `/tasks/${taskId}/result/preview-pdf`,
    method: 'get',
    responseType: 'blob'
  })
}
